var render, staticRenderFns
import script from "./SentenceLines.vue?vue&type=script&lang=js"
export * from "./SentenceLines.vue?vue&type=script&lang=js"
import style0 from "./SentenceLines.vue?vue&type=style&index=0&id=727647f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727647f4",
  null
  
)

export default component.exports